import * as React from 'react';
export const defaultPressableContextProps = {
  color: 'default',
  cursor: 'default',
  display: 'inline-flex',
  fontLineHeight: 20,
  fontSize: 14,
  fontWeight: 'regular',
  height: 'auto',
  pressableContextClasses: 'PressableContext',
  width: 'auto'
};
const PressableContext = /*#__PURE__*/React.createContext(defaultPressableContextProps);
export default PressableContext;